import {
  Box,
  Button,
  Paper,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ProductCarousel from "./ProductCarouselComponent";
import MeetingModal from "./MeetingModal";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import useGAEventsTracker from "./GAEventsHook";
import BannerSection from "./BannerSection";
import { CenterBox, LeftBox } from "./commons/BoxAbstraction";
import ProductCard from "./ProductCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ImageCarousel from "./Carousel";
import { useState } from "react";
import { ShopTwoRounded } from "@mui/icons-material";

export default function PersonalProductsPage() {
  const GAEventsTracker = useGAEventsTracker("Health Tools Activity");
  const [showMeeting, setShowMeeting] = useState(false);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  
  // Background SVG path - same as user journey page
  const backgroundSvgPath = "/images/userJourney/assets/job297-ploy-07c-blue-01.svg";

  const handleClose = () => {
    setOpen(false);
  };

  const slides = [
    {
      title: isSmallScreen ? "Video Report" : "Smart Video Report",
      heading: "Smart Video Report",
      description:
        "Experience the future of personalized healthcare with AI Report Summary as Video! We use Generative AI to create a unique diagnostic journey for each patient, complete with individualized concern areas & health tips. Offer the best to your patients with mobile-friendly design, customizable options, realistic avatars, ChatGPT prompts, and support for multiple languages.",
      illustration: "",
      audio:
        "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/audios/AI-video_voice_note.mp3",
      sample: "",
    },
    {
      title: isSmallScreen ? "Analytics" : "Analytics",
      heading: "Analytics",
      description:
        "NiroGyan’s B2B analytics solution empowers diagnostic labs and healthcare providers to transform lab data into actionable insights. Our platform provides real-time analytics on patient demographics, test utilization, and health trends, helping labs optimize resources and improve patient outcomes. With intuitive dashboards and advanced AI, labs can uncover health patterns, monitor KPIs, and enhance patient engagement, turning raw data into a strategic asset for smarter, data-driven decisions.",
      illustration: "personal1.svg",
      audio:
        "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/health-risk-audio.mp3",
      sample: "",
    },
    {
      title: isSmallScreen ? "Whatsapp Chatbot" : "Chatbot",
      heading: "Chatbot",
      description:
        "One-way messaging is old & spammy. Go for our two-way Smart WhatsApp Chatbot, which is the most easily-relatable way to engage new-age patients, answer their post-test queries, and enable them to purchase check-ups through the Bot itself.",
      illustration: "personal2.svg",
      audio:
        "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/audios/chatBotAudio.mp3",
      sample: "",
    },
    {
      title: "Corporate Dashboard",
      heading: "Corporate Dashboard",
      description:
        "Gamified population analytics and health insights as a user-friendly dashboard for Corporate leaders. Trusted by Fortune 500 firms for annual health checkup of employees. Also comes with corporate fitness reports",
      illustration: "personal3.svg",
      audio:
        "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/coorporateDashaudio.mp3",
      sample: "",
    },
  ];

  const bannerContent = {
    title: "Health Tools",
    description:
      "New-age products, built with Artificial Intelligence, to engage patients outside their reports.",
    image: "healthToolsImage.svg",
    styles: { imageWidth: isSmallScreen ? "180px" : "393px" },
    features: [
      {
        logo: (
          <DeveloperBoardIcon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "AI Powered",
      },
      {
        logo: (
          <Diversity2Icon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "Highly Engaging",
      },
      {
        logo: (
          <AutoFixHighIcon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "Customisable",
      },
    ],
    buttonText: "Book Now",
    link: "",
    gaEvents: {
      category: "Health Tools Activity",
      action: "Demo Booked",
    },
  };

  const healthToolsFeatures = {
    features: [
      {
        title1: "Follow-up ",
        title2: "Engines",
        description:
          "Go for our two-way Smart WhatsApp Chatbot, which is the most easily-relatable way to engage new-age patients  and enable them to purchase check-ups through the Bot itself.",
        image: "followUp.png",
        showButton: true,
        buttonText: "Preview",
        picture:
          "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/whatsApp_chatbot.svg",
      },
      {
        title1: "AI - Video",
        title2: "Report",
        description: "",
        image: "aiVideo.gif",
        imageStyles: {
          border: "7px solid #407BFF",
          borderRadius: "16px",
        },
      },
      {
        title1: "Advanced",
        title2: "Analytics",
        description:
          "NirogGyan turns lab data into real-time insights, optimizing resources, enhancing patient engagement, and driving smarter decisions.",
        image: "advancedAnalytics.png",
      },
      {
        title1: "Corporate",
        title2: "Dashboard",
        description:
          "Gamified health analytics for corporate leaders, trusted by Fortune 500 firms for employee health checkups and fitness reports.",
        image: "corporateDashboard.png",
        showButton: true,
        buttonText: "Try Now",
        externalUrl: "https://demo-corporate-dashboard.niroggyan.com",
      },
    ],
  };

  const previewDialog = (each) => {
    return (
      <Dialog
        sx={{ "& .MuiDialog-paper": { margin: "16px" } }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle fontSize={"16px"}>
          {each.title1 + " " + each.title2 + " Preview"}{" "}
        </DialogTitle>
        <DialogContent>
          <img
            src={each.picture}
            alt={each.title1}
            style={{ maxHeight: "100%", maxWidth: "100%", padding: "8px" }}
          />
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        overflowX: "hidden",
        // Background SVG - same as user journey page
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          padding: { xs: "96px 16px 40px", sm: "96px 24px 40px", md: "96px 48px 40px" },
        }}
      >
        <BannerSection data={bannerContent} setShowMeeting={setShowMeeting} />
      <Stack direction="column">
        <Box
          sx={{
            background: isSmallScreen ? "" : "rgba(64, 123, 255, 0.23)",
            boxShadow: isSmallScreen
              ? ""
              : "4px 4px 2.1px 0px rgba(0,0,0,0.25)",
            paddingY: !isSmallScreen && "24px",
            borderRadius: "40px",
            marginTop: "38px",
          }}
        >
          <Typography
            sx={{ textAlign: "center" }}
            mb={isSmallScreen ? "16px" : "27px"}
            variant={isSmallScreen ? "body3" : "h3"}
          >
            Health Tools Features
          </Typography>
          <CenterBox
            sx={{
              gap: isSmallScreen ? "10px" : "24px",
              flexWrap: isSmallScreen ? "wrap" : "",
            }}
          >
            {healthToolsFeatures.features.map((each) => (
              <Box
                sx={{
                  width: isSmallScreen ? "165px" : "265px",
                  height: isSmallScreen ? "390px" : "570px",
                  background: "#022674",
                  padding: isSmallScreen ? "10px 14px" : "14px 22px",
                  borderRadius: "20px",
                  boxShadow: "0px 4px 4px 2px rgba(0,0,0,0.25)",
                }}
              >
                <Typography
                  variant={isSmallScreen ? "body1" : "h3"}
                  sx={{ color: "#7BB58C" }}
                >
                  {each.title1}
                </Typography>
                <Typography
                  variant={isSmallScreen ? "body1" : "h3"}
                  sx={{ color: "#fff" }}
                >
                  {each.title2}
                </Typography>
                <Box sx={{ textAlign: "center" }}>
                  <Box
                    component="img"
                    alt="health-tools"
                    src={`/images/${each.image}`}
                    sx={{
                      margin: "25px 0px",
                      width: isSmallScreen ? "78%" : "90%",
                      ...(each?.imageStyles || ""),
                    }}
                  />
                </Box>
                <Typography
                  variant={isSmallScreen ? "h4Mobile" : "body2"}
                  sx={{ color: "#fff" }}
                >
                  {each.description}
                </Typography>

                {/* preview butto  */}
                <Stack direction="row" alignItems="center" gap={2} mt={2}>
                  {each?.showButton ? (
                    <Button
                      variant={isSmallScreen ? "mobile" : "contained"}
                      sx={{
                        padding: isSmallScreen
                          ? "3px 3px 3px 6px"
                          : "3px 3px 3px 12px ",
                        background: "#7BB58C",
                        borderRadius: "12px",
                        textTransform: "none",
                      }}
                      onClick={() => {
                        GAEventsTracker(
                          `${each.title1} ${each.title2} Preview Viewed`,
                          "successfully"
                        );
                        if (each?.picture) {
                          setOpen(true);
                        }
                        if (each?.externalUrl) {
                          window.open(each.externalUrl, "_blank");
                        }
                      }}
                    >
                      <LeftBox gap={isSmallScreen ? "6px" : "12px"}>
                        <Typography
                          sx={{
                            color: "#fff",
                            fontSize: isSmallScreen ? "10px" : "",
                          }}
                        >
                          {each.buttonText}
                        </Typography>
                        <CenterBox
                          sx={{
                            width: isSmallScreen ? "24px" : "35px",
                            height: isSmallScreen ? "16px" : "25px",
                            background: "#fff",
                            borderRadius: "12px",
                          }}
                        >
                          {each?.picture ? (
                            <VisibilityIcon
                              sx={{
                                color: "#4C4C4C",
                                fontSize: isSmallScreen ? "16px" : "24px",
                              }}
                            />
                          ) : (
                            <ArrowForwardIcon
                              sx={{
                                color: "#4C4C4C",
                                fontSize: isSmallScreen ? "16px" : "24px",
                              }}
                            />
                          )}
                        </CenterBox>
                      </LeftBox>
                    </Button>
                  ) : (
                    ""
                  )}
                  {/* {previewDialog()} */}
                  {each?.picture ? previewDialog(each) : ""}
                </Stack>
              </Box>
            ))}
          </CenterBox>
        </Box>
      </Stack>
      <MeetingModal showMeeting={showMeeting} setShowMeeting={setShowMeeting} />
      </Box>
    </Box>
  );
}
